import { Component, OnInit } from '@angular/core';
import { Albaran } from 'src/app/interfaces/albaran';
import { AlertController } from '@ionic/angular';
import { RestService } from 'src/app/services/rest/rest.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { User } from 'src/app/interfaces/user';
import { Client } from 'src/app/interfaces/client';
import { Product } from 'src/app/interfaces/product';
import { ProductByNAME, ProductInitialsByID, ProductListInitials } from 'src/app/data/products';
import { SessionService } from 'src/app/services/session/session.service';

@Component({
  selector: 'app-albaranes',
  templateUrl: './albaranes.page.html',
  styleUrls: ['./albaranes.page.scss'],
})
export class AlbaranesPage implements OnInit {
  searchAlbaranID: string;
  searchClient: string;
  selectedView = 'main';
  editFields = false;
  editedId: string;
  clientChanged = false;
  clientAux: string;
  clientCommentRequired = false;
  clientField: string;
  dateField: string;
  timeField: string;
  totalField: number;
  repartidorField: string;
  comentarioField: string;
  tarifasClient: any;
  productsClient: any;
  delivered = false;
  sessionLinked = null;
  // Changes everytime a different "repartidor" is chosen
  userCargas: any;
  userAlbs: any;
  linkedMode = false;

  users: User[];
  clients: Client[] = [];
  products: Product[];
  albaranesCurrentSession: any[];

  originalCantidad = {};
  

  columns = [
    {
      field: 'id',
      name: 'id',
      width: 8
    },
    {
      field: 'zona',
      name: 'zona',
      width: 5
    },
    {
      field: 'nombreCliente',
      name: 'Cliente',
      width: 15
    },
    {
      field: 'fecha',
      name: 'Fecha y hora',
      width: 10
    },
    {
      field: 'qnt',
      name: 'Cantidad',
      width: 6
    },
    {
      field: 'facturado',
      name: 'Facturado',
      width: 7
    },
    {
      field: 'nombreUser',
      name: 'Empleado',
      width: 8
    },
    {
      field: 'deleted',
      name: 'Eliminado',
      width: 6,
      type: 'boolean',
      bolValues: {
        true: 'Sí',
        false: 'No'
      }
    },
    {
      field: 'action',
      name: 'acciones rápidas',
      width: 8,
      actions: [
        {
          type: 'delete'
        },
        {
          type: 'edit'
        }
      ]
    }
  ];

  lines = [];
  repartidorName: any;
  usuarioFake = false;
  currentPage = 0;
  maxPage = 0;
  totalWithIva = 0;
  isEdit = false;
  lineSelected: any;

  constructor(private alert: AlertController,
    private rest: RestService,
    private session: SessionService,
    private utils: UtilsService) { }

  async ionViewWillEnter() {
    try {
      console.log('show LOAD');
      await this.utils.showLoading();
      await this.getAlbaranes();
      await this.getUsers();
      await this.getAlbaranesCurrentSessionGrouped();
      await this.utils.hideLoading();
    } catch (error) {
      console.log(error);
      await this.utils.hideLoading();
    }
  }

  ionViewWillLeave() {
    this.searchAlbaranID = null;
    this.searchClient = null;
    this.currentPage = 0;
    this.lines = [];
    this.maxPage = 0;
    this.totalWithIva = 0;
  }

  ngOnInit() { }

  async getProducts() {
    const resp: any = await this.rest.getProducts(1, 1000);
    if (resp.body && resp.body.records) {
      this.products = resp.body.records;
      console.log(this.products);
    }
  }

  async getUsers() {
    const result: any = await this.rest.getUsersWithCargas(1, 1000);
    this.users = result.body.records;

    const resp: any = await this.rest.getCurrentCargas();
    if (resp && resp.body && resp.body.records) {
      let cargas = resp.body.records;
      cargas = cargas.map(e => {
        return {
          product: e.product,
          user: e.user._id,
          closed: e.closed
        }
      });
      cargas = this.groupByCargas(cargas, 'user');
      this.users.forEach(
        user => {
          const aux = cargas[user._id];

          user.cargas = aux || [];
        }
      );
      console.log(this.users);
      this.users = this.users.filter(u => u.cargas.length > 0 && u.role === 'repartidor');
      console.log(this.users);
    }
  }

  async changeClientInput(event) {
    console.log('show LOAD');
    await this.utils.showLoading();
    try {
      this.clientAux = event;
      this.clientChanged = true;
      if (this.clientAux !== '') {
        const resp = await this.rest.getClientsByName(this.clientAux);
        if (resp.body) {
          this.clients = resp.body.records;
          console.log(this.clients);
        }
      } else {
        this.productsClient = [];
        this.tarifasClient = [];
      }
      await this.utils.hideLoading();
    } catch (error) {
      console.log(error);
      await this.utils.hideLoading();
    }
  }

  async selectClient(client: any) {
    
    this.changeTotal();
    this.clientField = client._id;
    this.clientAux = client.nombre;
    this.clientCommentRequired = client.commentRequired;
    const tarifasDefault = await this.getDefaultTarifas();
    this.tarifasClient = client.tarifa || [];
    this.products.forEach(
      prod => {
        const aux = this.tarifasClient.filter(elem => elem.product === prod.name);
        if (!aux || aux.length === 0) {
          this.tarifasClient[prod.name] = tarifasDefault.filter(t => t.product === prod.name);
          this.tarifasClient[prod.name] = this.tarifasClient[prod.name][0];
        }
      }
    );

    console.log(this.tarifasClient);
    this.clientChanged = false;
    try {
      console.log('show LOAD');
      await this.utils.showLoading();
      const productsFromTarifas = this.tarifasClient.map(t => t.product);
      // We store both the name and id of the products
      this.productsClient = this.products;
      console.log(this.productsClient);
      this.productsClient.forEach(
        product => {
          const auxId = product._id;
          delete product._id;
          product.product = auxId;
          let p = this.tarifasClient.filter(e => e.product === product.name);
          if (!p || p.length === 0) {
            p = this.tarifasClient[product.name];
            if (this.isEdit) {
              this.lineSelected.cantidad.forEach(elem => {
                if (elem.product === product.product) {
                  product.price = p.price ? p.price : elem.price;
                  product.priceShow = (p.price ? p.price : elem.price) + ('(' + elem.price + ')').toString();
                }
              });
            } else {
              product.price = p.price;
            }
            product.iva = p.iva;
            product.ivaRequered = p.ivaRequered;
          }
          if (p.length > 0) {
            if (this.isEdit) {
              this.lineSelected.cantidad.forEach(elem => {
                if (elem.product === product.product) {
                  product.price = p[0].price ? p[0].price : elem.price;
                  product.priceShow = (p[0].price ? p[0].price : elem.price) + ('(' + elem.price + ')').toString();
                }
              });
            } else {
              product.price = p[0].price;
            }
            product.iva = p[0].iva;
            product.ivaRequered = p[0].ivaRequered;
          }
        }
      );
      console.log(this.productsClient);
      await this.utils.hideLoading();
    } catch (error) {
      console.log(error);
      await this.utils.hideLoading();
    }
  }

  async getDefaultTarifas() {
    let res = [];
    const resp: any = await this.rest.getDefaultTarifas();
    if (resp) {
      res = resp.body.records;
      console.log(res);
    }
    return res;
  }

  changeView(view: string) {
    this.selectedView = view;
  }

  async addNew() {
    this.isEdit = false;
    this.selectedView = 'editMode';
    this.delivered = false;
    this.clearData();
    this.editFields = false;
    console.log('addnew');
    try {
      console.log('show LOAD');
      await this.utils.showLoading();
      await this.getProducts();
      await this.utils.hideLoading();
    } catch (error) {
      console.log(error);
      await this.utils.hideLoading();
    }
  }

  async getAlbaranes() {
    console.log('this.currentPage:', this.currentPage);
    
    const result: any = await this.rest.getAlbaranes(this.currentPage + 1, 20);
    this.maxPage = Math.ceil((result.body.total / 20) + ((result.body.total % 20 > 0) ? 1 : 0));

    // const result: any = await this.rest.getAlbaranes(1, 17);
    if (result.body) {
      this.lines = [];
      result.body.records.forEach(
        elem => {
          elem.zona = elem.cliente && elem.cliente.zona ? elem.cliente.zona : '';
          elem.nombreCliente = elem.cliente && elem.cliente.nombre ? elem.cliente.nombre : '';
          elem.cliente = elem.cliente ? elem.cliente._id : '';
          elem.nombreUser = elem.empleado && elem.empleado.firstName ? elem.empleado.firstName : '';
          elem.empleado = elem.empleado ? elem.empleado._id : '';
          this.lines.push(elem);
        }
      )
      // this.lines = result.body.records;
    }
    // await this.getAlbaranesCurrentSessionGrouped();
    // this.lines.forEach(albaran => {
    //   if (albaran.fecha) {
    //     const time = new Date(albaran.fecha).toLocaleTimeString('es-ES').slice(0, -3);
    //     albaran.fecha = new Date(albaran.fecha).toLocaleDateString('es-ES');
    //     albaran.fecha = albaran.fecha + ' - ' + time;
    //   }
    //   if (albaran.nombreUser === 'usuarioFake') {
    //     albaran.nombreUser = 'Albaran sin repartidor asignado'
    //   }

    //   const products = [];
    //   albaran.cantidad.forEach(product => {
    //     if (product.unit !== 0) {
    //       products.push(ProductInitialsByID(product.product) + ' ' + product.unit);
    //     }
    //   });
    //   albaran.qnt = products.join(', ');
    //   this.lines = this.lines.filter(line => line.delivered);
    // })

    for (const albaran of this.lines) {
      if (albaran.fecha) {
        const time = new Date(albaran.fecha).toLocaleTimeString('es-ES').slice(0, -3);
        albaran.fecha = new Date(albaran.fecha).toLocaleDateString('es-ES');
        albaran.fecha = albaran.fecha + ' - ' + time;
      }
      if (albaran.nombreUser === 'usuarioFake') {
        albaran.nombreUser = 'Albaran sin repartidor asignado'
      }

      const products = [];
      albaran.cantidad.forEach((product, index) => {
        if (product.unit && product.unit !== 0) {
          products.push(ProductListInitials[index] + ' ' + product.unit);
        }
      });
      albaran.qnt = products.join(', ');
      this.lines = this.lines.filter(line => line.delivered);
      this.lines = this.lines.sort((a, b) => new Date(b.fecha).getTime() - new Date(a.fecha).getTime());
    }
    console.log(this.lines);
    // this.lines= this.lines.sort((a, b) => b.createdAt - a.createdAt);
    const facturado = [];
    const noFacturado = [];
    this.lines.forEach(line => {
      if (line.facturado) {
        facturado.push(line);
      } else {
        noFacturado.push(line);
      }
    })
    this.lines = [];
    noFacturado.forEach(noFactur => {
      this.lines.push(noFactur)
    })
    facturado.forEach(factur => {
      this.lines.push(factur)
    })
  }

  async saveItem() {

    let invalid = false;
    const fecha: any = new Date(this.dateField + ' ' + this.timeField);
    // fecha = fecha.getTime() + 7200000;
    const newFecha = new Date();
    newFecha.setTime(fecha);
    const sendAlbaran: Albaran = {
      cliente: this.clientField,
      fecha: newFecha, // To avoid timezone offset
      total: this.totalField,
      empleado: this.repartidorField,
      comment: this.comentarioField,
      regalos: [],
      delivered: this.delivered
    };

    sendAlbaran.cantidad = [...this.productsClient];
    if (sendAlbaran.cantidad.length > 0) {
      sendAlbaran.cantidad.forEach(
        (c) => {
          if (!c.unit) {
            c.unit = 0;
          }
        }
      );

      console.log(sendAlbaran.cantidad);
    }
    if (this.repartidorField !== '5f0c2b821d2f0703ebf97e46') {
      sendAlbaran.cantidad.forEach(
        prod => {
          const p: any = this.userCargas[prod.product];
          console.log(this.userCargas[prod.product]);
          console.log(prod.unit);
          if (!p) {
            this.userCargas[prod.product] = 0;
          }
          if (!this.userAlbs) {
            this.userAlbs = {};
          }
          if ((((this.userCargas[prod.product] || 0) - (this.userAlbs[prod.product] || 0)) < prod.unit)
            && (prod.product !== '5ef5e43bdd4795f0c32a1530' && prod.product !== '5ef5e43bdd4795f0c32a152f')) {
            this.utils.showToast('El número de unidades es mayor al que dispone el repartidor', 'danger', 3000);
            invalid = true;
          }
        }
      );
    }
    sendAlbaran.regalos = await this.fillPromocion(sendAlbaran);
    if (!invalid) {
      await this.utils.showLoading();
      sendAlbaran.delivered = !this.delivered;
      console.log(sendAlbaran);

      let iva: any;
      let ivaCount = 0;
      this.productsClient.forEach(element => {
        iva = ((element.price * element.unit) * ((100 + element.iva) / 100));
        ivaCount = ivaCount + iva;
      })
      sendAlbaran.totalWithIva = ivaCount;

      const result = await this.rest.createAlbaran(sendAlbaran);
      console.log(result);
      if (result) {
        // this.lines.unshift(sendAlbaran);
        this.clearData();
        if (sendAlbaran.delivered) {
          await this.rest.createNotifications([sendAlbaran.empleado], 'albaran');
        }
        await this.getAlbaranes();
        await this.getAlbaranesCurrentSessionGrouped();
        this.selectedView = 'main';
      }
      await this.utils.hideLoading();
    }
  }

  changeTotal() {
    this.totalField = 0;
    if (this.productsClient) {
      this.productsClient.forEach(
        elem => {
          this.totalField += (elem.unit * elem.price) || 0;
        }
      );
    }
    (this.totalField as any) = this.utils.parseDecimals(this.totalField);
  }

  parseDecimals(num: number) {
    return this.utils.parseDecimals(num);
  }

  calcTotalWithIva(line: any) {
    const multi = 1 + (line.iva / 100);
    return this.parseDecimals((line.price * line.unit * multi));
  }

  totalPriceWithIva() {
    this.totalWithIva = 0;
    for (const line of this.productsClient) {
      let result = this.calcTotalWithIva(line);
      result = result.toString();
      
      this.totalWithIva = this.totalWithIva + parseFloat(result);
    }
  }

  totalProdutos(prod) {
    return (((this.userCargas && this.userCargas[prod.product]) ? this.userCargas[prod.product] : 0) -
      ((this.userAlbs && this.userAlbs[prod.product]) ? this.userAlbs[prod.product] : 0))
  }

  async editItem() {
    let invalid = false;
    const fecha: any = new Date(this.dateField.toString() + ' ' + this.timeField.toString());
    const newFecha = new Date();
    newFecha.setTime(fecha);
    const sendAlbaran: Albaran = {
      _id: this.editedId,
      cliente: this.clientField,
      fecha: newFecha, // To avoid timezone offset
      total: this.totalField,
      empleado: this.repartidorField,
      comment: this.comentarioField,
      delivered: this.delivered
    };

    sendAlbaran.cantidad = this.productsClient;
    if (sendAlbaran.cantidad.length > 0) {
      sendAlbaran.cantidad.forEach(
        (c) => {
          if (!c.unit || c.unit === 0) {
            sendAlbaran.cantidad = sendAlbaran.cantidad.filter(elem => elem.product !== c.product);
          }
        }
      );
    }
    if (this.repartidorField !== '5f0c2b821d2f0703ebf97e46') {
      // this.fillUserCargas(sendAlbaran.empleado);

      sendAlbaran.cantidad.forEach(
        prod => {
          const p: any = this.userCargas[prod.product];
          if (p) {
            this.userAlbs = this.userAlbs || [];
            if (((p - this.userAlbs[prod.product] + this.originalCantidad[prod.product]) < prod.unit)
              && (prod.product !== '5ef5e43bdd4795f0c32a1530' && prod.product !== '5ef5e43bdd4795f0c32a152f')) {
              this.utils.showToast('El número de unidades es mayor al que dispone el repartidor', 'danger', 3000);
              invalid = true;
            }
          } else if (p !== 0) {
            console.log(p);
            // Case where repartidor doesnt have that product in its cargas
            this.utils.showToast('El número de unidades es mayor al que dispone el repartidor', 'danger', 3000);
            invalid = true;
          }
        }
      );
    }
    if (!invalid) {
      await this.utils.showLoading();

      let iva: any;
      let ivaCount = 0;
      this.productsClient.forEach(element => {
        iva = ((element.price * element.unit) * ((100 + element.iva) / 100));
        ivaCount = ivaCount + iva;
      })
      sendAlbaran.totalWithIva = ivaCount;
      const result = await this.rest.editAlbaran(sendAlbaran);

      console.log(result);
      if (result) {
        this.utils.showToast('Albarán atualizado con éxito', 'success', 3000);
        setTimeout(
          () => location.reload()
          , 400);
      }
      await this.utils.hideLoading();
    }
  }

  async doAction(data) {
    console.log(data);
    const albaran: Albaran = data.line;
    if (data.action === 'delete') {
      this.deleteItem(albaran);
    }
    if (data.action === 'edit') {
      console.log('edit');
      this.lineSelected = data.line;
      this.isEdit = true;
      this.selectedView = 'editMode';
      await this.getProducts();
      const resp: any = await this.rest.getClient((albaran.cliente));
      this.editedId = albaran._id;
      console.log(this.editedId);
      this.clientField = albaran.cliente;
      await this.selectClient(resp.body);

      if (albaran.fecha) {
        let auxDate: any = albaran.fecha.toString().split(' - ')[0];
        auxDate = auxDate.split('/');
        auxDate[0] = ('0' + auxDate[0]).slice(-2);
        auxDate[1] = ('0' + auxDate[1]).slice(-2);
        auxDate = auxDate.reverse().join('-');

        this.dateField = auxDate;
        this.timeField = albaran.fecha.toString().split(' - ')[1];

        console.log(this.timeField);
      } else {
        this.dateField = '';
        this.timeField = '';
      }
      this.totalField = albaran.total;
      console.log(albaran);
      this.productsClient.forEach(
        p => {
          const productAlbaran: any = albaran.cantidad.filter(e => e.product === p.product);
          if (productAlbaran.length > 0) {
            p.unit = productAlbaran[0].unit;
          } else {
            p.unit = 0;
          }
          this.originalCantidad[p.product] = p.unit;
        }
      );
      console.log(albaran.empleado);
      this.repartidorField = albaran.empleado;
      this.fillUserCargas(albaran.empleado);
      this.comentarioField = albaran.comment;
      await this.getEditRepartidor(albaran);
      this.editFields = true;
    }
  }

  async getEditRepartidor(albaran: any) {
    console.log(this.users);
    const result: any = await this.rest.getUser(albaran.empleado);
    let userIds: any;
    if (this.users && this.users.length > 0) {
      userIds = this.users.map(elem => elem._id);
    }
    if (!userIds || userIds.length === 0 || !userIds.includes(result.body._id)) {
      this.users.push(result.body);
    }
    this.users.forEach(user => {
      if (user.firstName === 'usuarioFake') {
        user.firstName = 'Sin asignar repartidor';
        user.lastName = '';
        this.usuarioFake = true;
      }
    })
  }

  fillUserCargas(empleado: any) {
    if (empleado !== '5f0c2b821d2f0703ebf97e46') {
      console.log(this.albaranesCurrentSession);
      this.userCargas = [];
      this.userAlbs = [];
      const user = this.users.filter(u => u._id === empleado);

      if (user.length > 0 && user[0].cargas && user[0].cargas.length > 0) {
        const openCargas = user[0].cargas.filter(elem => elem.closed === false);
        this.userCargas = openCargas.length > 0 ? openCargas.map(e => e.product) : [];

        this.userCargas = this.groupByUnitsAndProducts(this.userCargas.flat(), '_id');
        if (this.userCargas && Object.keys(this.userCargas).length > 0) {
          Object.keys(this.userCargas).forEach(
            key => {
              this.userCargas[key] = this.userCargas[key].reduce((a, b) => a + b, 0);
            }
          );
        }
        // LÓGICA TENIENDO EN CUENTA ALBARANES DE LA SESIÓN
        this.userAlbs = this.albaranesCurrentSession[user[0].username];
        if (this.userAlbs && this.userAlbs.length > 0) {
          this.userAlbs = this.userAlbs.filter(elem => elem.closed === false);
          this.userAlbs = this.userAlbs.map(alb => alb.cantidad);
          this.userAlbs = this.groupByUnitsAndProductsLong(this.userAlbs.flat(), 'product');
          if (this.userAlbs && Object.keys(this.userAlbs).length > 0) {
            Object.keys(this.userAlbs).forEach(
              key => {
                this.userAlbs[key] = this.userAlbs[key].map(elem => elem.units);
                this.userAlbs[key] = this.userAlbs[key].reduce((a, b) => a + b, 0);
              }
            );
          }
        }
      } else {
        this.userCargas = {};
      }
      console.log(this.userAlbs);
      console.log(this.userCargas);

    }
  }

  async deleteItem(albaran: Albaran) {
    const alert = await this.alert.create({
      header: '¿Borrar?',
      message: 'Borrar albaran ' + albaran.id,
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          cssClass: 'secondary'
        }, {
          text: 'Sí',
          handler: async () => {
            console.log('Item to remove!!!');
            console.log('show LOAD');
            await this.utils.showLoading();
            await this.rest.deleteAlbaran(albaran._id);
            await this.getAlbaranes();
            await this.getAlbaranesCurrentSessionGrouped();
            await this.utils.hideLoading();
          }
        }
      ]
    });
    await alert.present();
  }

  clearData() {
    this.clientField = '';
    this.dateField = '';
    this.timeField = '';
    this.totalField = null;
    this.repartidorField = '';
    this.comentarioField = '';
    this.clientAux = '';
    this.tarifasClient = null;
    this.productsClient = null;
  }

  groupByUnitsAndProducts(xs, key) {
    return xs.reduce((rv, x) => {
      (rv[x[key]] = rv[x[key]] || []).push(x.unit);
      return rv;
    }, {});
  };

  groupByCargas(xs, key) {
    return xs.reduce((rv, x) => {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };

  groupByUnitsAndProductsLong(xs, key) {
    return xs.reduce((rv, x) => {
      (rv[x[key]] = rv[x[key]] || []).push({ units: (x.unit ? x.unit : 0) });
      return rv;
    }, {});
  };

  async getAlbaranesCurrentSessionGrouped() {
    try {
      const resp: any = await this.rest.getAlbaranesCurrentSessionGrouped();
      if (resp) {
        this.albaranesCurrentSession = resp.body;
      }
      return true;
    } catch (error) {
      console.log(error);
      return null;
    }
  }
  async search() {
    console.log('search');
    try {
      await this.utils.showLoading();
      if (!this.searchAlbaranID && !this.searchClient) {
        await this.getAlbaranes();
      } else {
        this.currentPage = 0;
        const resp = await this.rest.getAlbaranesBySearch(this.currentPage, 20, this.searchAlbaranID, this.searchClient);
        this.maxPage = Math.ceil((resp.body.total / 20) + ((resp.body.total % 20 > 0) ? 1 : 0));
        this.lines = [];
        console.log(resp.body.records);

        resp.body.records.forEach(
          elem => {
            elem.zona = elem.cliente && elem.cliente.zona ? elem.cliente.zona : '';
            elem.nombreCliente = elem.cliente && elem.cliente.nombre ? elem.cliente.nombre : '';
            elem.cliente = elem.cliente ? elem.cliente._id : '';
            elem.nombreUser = elem.empleado && elem.empleado.firstName ? elem.empleado.firstName : '';
            elem.empleado = elem.empleado ? elem.empleado._id : '';
            const time = new Date(elem.fecha).toLocaleTimeString('es-ES').slice(0, -3);
            elem.fecha = new Date(elem.fecha).toLocaleDateString('es-ES');
            elem.fecha = elem.fecha + ' - ' + time;

            const products = [];
            elem.cantidad.forEach((product, index) => {
              if (product.unit && product.unit !== 0) {
                products.push(ProductListInitials[index] + ' ' + product.unit);
              }
            });
            elem.qnt = products.join(', ');

            this.lines.push(elem);
          }
        );
      }
      this.currentPage = 0;
      await this.utils.hideLoading();
    } catch (error) {
      console.log(error);
      await this.utils.hideLoading();
      await this.utils.showToast('Error buscando albaranes', 'danger', 3000);
    }
  }

  checkValidFields() {
    if (!this.productsClient || !this.repartidorField || !this.clientAux ||
      !this.dateField || !this.timeField) {
      return true
    }

    if (!this.comentarioField && this.clientCommentRequired) {
      return true;
    }


    if (this.productsClient.length > 0) {
      for (const products of this.productsClient) {
        if (products.unit !== undefined) {
          console.log()
        }
      }
    }

    if (this.totalField < 1) {
      return true;
    }
  }

  async fillPromocion(albaran: any) {
    let regalo: any;
    let promociones: any;
    const resp: any = await this.rest.getClient(albaran.cliente);
    if (resp) {
      console.log(resp.body);
      promociones = resp.body.promocion;
    }
    if (promociones && promociones.length > 0) {
      console.log(albaran.cantidad);
      this.productsClient = albaran.cantidad;
      this.productsClient.forEach(
        elem => {
          console.log(promociones);
          console.log(elem);
          let prod: any = promociones.filter(e => ProductByNAME(e.product) === elem.product);
          if (prod && prod.length > 0) {
            prod = prod[0];
            console.log(prod);
            regalo = (elem.unit / prod.venta) * parseInt(prod.regalo, 10);
            if (regalo > 0) {
              albaran.regalos.push({
                product: elem.product,
                unit: Math.trunc(parseInt(regalo, 10))
              });
            }
          }
        }
      );

      // await this.utils.showAlertOnlyButtonOk('Promoción regalo al cliente', null, result);
    }
    return albaran.regalos || [];
  }

  async pagination(event: any) {
    console.log('event', event);
    
    if ((this.currentPage + event >= 0) && (this.currentPage + event <= this.maxPage)) {
      this.currentPage += event;
    }
    console.log(this.currentPage);
    if (this.searchAlbaranID || this.searchClient) {
      const resp = await this.rest.getAlbaranesBySearch(this.currentPage, 20, this.searchAlbaranID, this.searchClient);
      this.maxPage = Math.ceil((resp.body.total / 20) + ((resp.body.total % 20 > 0) ? 1 : 0));
      this.lines = [];
      console.log(resp.body.records);
      resp.body.records.forEach(
        elem => {
          elem.zona = elem.cliente && elem.cliente.zona ? elem.cliente.zona : '';
          elem.nombreCliente = elem.cliente && elem.cliente.nombre ? elem.cliente.nombre : '';
          elem.cliente = elem.cliente ? elem.cliente._id : '';
          elem.nombreUser = elem.empleado && elem.empleado.firstName ? elem.empleado.firstName : '';
          elem.empleado = elem.empleado ? elem.empleado._id : '';
          const time = new Date(elem.fecha).toLocaleTimeString('es-ES').slice(0, -3);
          elem.fecha = new Date(elem.fecha).toLocaleDateString('es-ES');
          elem.fecha = elem.fecha + ' - ' + time;

          const products = [];
          elem.cantidad.forEach((product, index) => {
            if (product.unit && product.unit !== 0) {
              products.push(ProductListInitials[index] + ' ' + product.unit);
            }
          });
          elem.qnt = products.join(', ');

          this.lines.push(elem);
        }
      );
    } else {
      await this.getAlbaranes();
    }
  }

  async refreshPage() {
    try {
      await this.utils.showLoading();
      await this.getAlbaranes();
      await this.getUsers();
      await this.getAlbaranesCurrentSessionGrouped();
      await this.utils.hideLoading();
    } catch (error) {
      console.log(error);
      await this.utils.hideLoading();
    }
  }


  async addItemToSession() {
    try {
      if (this.sessionLinked) {

        const invalid = false;
        const fecha: any = new Date(this.dateField + ' ' + this.timeField);
        // fecha = fecha.getTime() + 7200000;
        const newFecha = new Date();
        newFecha.setTime(fecha);
        const sendAlbaran: Albaran = {
          cliente: this.clientField,
          fecha: newFecha, // To avoid timezone offset
          total: this.totalField,
          empleado: null,
          comment: this.comentarioField,
          regalos: [],
          delivered: this.delivered,
          currentSession: false,
          closed: true
        };

        sendAlbaran.cantidad = [...this.productsClient];

        if (sendAlbaran.cantidad.length > 0) {
          sendAlbaran.cantidad.forEach(
            (c) => {
              if (!c.unit) {
                c.unit = 0;
              }
            }
          );

          console.log(sendAlbaran.cantidad);
        }
        if (this.repartidorField && this.repartidorField !== '5f0c2b821d2f0703ebf97e46') {
          sendAlbaran.cantidad.forEach(
            prod => {
              const p: any = this.userCargas[prod.product];
              console.log(this.userCargas[prod.product]);
              console.log(prod.unit);
              if (!p) {
                this.userCargas[prod.product] = 0;
              }
              if (!this.userAlbs) {
                this.userAlbs = {};
              }
            }
          );
        }
        sendAlbaran.regalos = await this.fillPromocion(sendAlbaran);
        if (!invalid) {
          await this.utils.showLoading();
          sendAlbaran.delivered = !this.delivered;
          console.log(sendAlbaran);

          let iva: any;
          let ivaCount = 0;
          this.productsClient.forEach(element => {
            iva = ((element.price * element.unit) * ((100 + element.iva) / 100));
            ivaCount = ivaCount + iva;
          })
          sendAlbaran.totalWithIva = ivaCount;

          const result = await this.rest.createAlbaran(sendAlbaran, this.sessionLinked);
          console.log(result);
          if (result) {
            // this.lines.unshift(sendAlbaran);
            this.clearData();
            if (sendAlbaran.delivered) {
              await this.rest.createNotifications([sendAlbaran.empleado], 'albaran');
            }
            await this.getAlbaranes();
            await this.getAlbaranesCurrentSessionGrouped();
            this.selectedView = 'main';
            this.sessionLinked = null;
          }
          await this.utils.hideLoading();
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
}
